export default "__VITE_ASSET__Bvjp$lzZ__"